/* Cliente REST do FAQ/capacidades (ADR-0658 + ADR-0720). Staff lista (paginado POR TÓPICO via
   keyset)/cria/edita/remove entries via `/v1/admin/faq` (cookie + RBAC no admin-service). A lista
   devolve tópicos já agrupados no servidor com todas as traduções. */
import {
  type BulkDeleteFaqTopicsResponse,
  bulkDeleteFaqTopicsResponseDto,
  type CreateFaqBody,
  type FaqTopic,
  faqTopicPageDto,
  type UpdateFaqBody,
} from '@planuze/admin-contracts';
import { ApiError, buildQuery, parseJson, readErrorCode, request } from './http.js';

async function faqError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'request failed');
}

interface FaqTopicsQuery {
  readonly cursor?: string | undefined;
  /* Filtro server-side por categoria (ADR-0728) — surfaces dedicadas (ex.: guia do publisher). */
  readonly categoryKey?: string | undefined;
}

/** GET /v1/admin/faq — página keyset de tópicos (`items` + `nextCursor`). */
export async function listFaqTopics(
  query: FaqTopicsQuery,
): Promise<{ readonly items: readonly FaqTopic[]; readonly nextCursor: string | null }> {
  const res = await request(
    `/v1/admin/faq${buildQuery({ cursor: query.cursor, categoryKey: query.categoryKey })}`,
  );
  if (!res.ok) throw await faqError(res);
  const page = await parseJson(res, faqTopicPageDto);
  return { items: page.items, nextCursor: page.nextCursor ?? null };
}

export async function createFaq(body: CreateFaqBody): Promise<void> {
  const res = await request('/v1/admin/faq', { method: 'POST', body });
  if (!res.ok) throw await faqError(res);
}

export async function updateFaq(id: string, body: UpdateFaqBody): Promise<void> {
  const res = await request(`/v1/admin/faq/${id}`, { method: 'PUT', body });
  if (!res.ok) throw await faqError(res);
}

export async function deleteFaq(id: string): Promise<void> {
  const res = await request(`/v1/admin/faq/${id}`, { method: 'DELETE' });
  if (!res.ok) throw await faqError(res);
}

export async function bulkDeleteFaqTopics(
  slugs: readonly string[],
): Promise<BulkDeleteFaqTopicsResponse> {
  const res = await request('/v1/admin/faq/bulk', {
    method: 'POST',
    body: { slugs, action: 'deleteTopics' },
  });
  if (!res.ok) throw await faqError(res);
  return parseJson(res, bulkDeleteFaqTopicsResponseDto);
}
